import layers from './layers'
import parcels from './parcels'
import mapSettings from './mapSettings'
import report from './report'
import screen from './screen'
import account from './account'
import navigation from './navigation'
import { START_NEW_PROJECT, SET_STORE } from '../actions/savedState'

const defaultState = {
    layers: layers(undefined, {}),
    mapSettings: mapSettings(undefined, {}),
    parcels: parcels(undefined, {}),
    report: report(undefined, {}),
    screen: screen(undefined, {}),
    account: account(undefined, {}),
    navigation: navigation(undefined, {})
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_STORE:
            // Saves incoming state over copy of current state. When 2nd-level state is an object,
            // saves 2nd-level incoming state over 2nd-level current state (stops at 2nd level).
            // This preserves the existing values when they do not exist in incoming state.
            return Object.entries(action.state).reduce((acc, cur) => {
                const [key, value] = cur
                // test for object
                if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
                    acc[key] = { ...acc[key], ...value }
                } else {
                    acc[key] = value
                }
                return acc
            }, JSON.parse(JSON.stringify(state)))
        case START_NEW_PROJECT:
            return { ...defaultState, account: JSON.parse(JSON.stringify(state.account)) }
        default:
            return {
                layers: layers(state.layers, action),
                mapSettings: mapSettings(state.mapSettings, action),
                parcels: parcels(state.parcels, action),
                report: report(state.report, action),
                screen: screen(state.screen, action),
                account: account(state.account, action),
                navigation: navigation(state.navigation, action)
            }
    }
}
